<script setup lang="ts">
import type { AgentContactSectionProps } from '.';
import type { AgentContactCardFormValues } from '~/components/AgentContactCard';

import { useAgentProfileStore } from '~/store/agentProfileStore';
import { storeToRefs } from 'pinia';

import { AgentContactCard } from '~/components/AgentContactCard';
import { Skeleton } from '~/components/ui/skeleton';

const props = defineProps<AgentContactSectionProps>();

const emit = defineEmits<{
	(e: 'submit', values: AgentContactCardFormValues): void;
}>();

const { profile } = storeToRefs(useAgentProfileStore());

const agentPictureSrc = computed(
	() =>
		profile.value?.profilePicture?.croppedUrl ||
		profile.value?.profilePicture?.url ||
		''
);
</script>

<template>
	<Skeleton
		v-if="isLoading"
		is-active
		variant="white"
		:class="[
			'h-[479px] w-full rounded-none motion-reduce:animate-none',
			props.class
		]"
		data-testid="agent-contact-section-skeleton"
		aria-label="Carregando formulário de contato"
		aria-busy="true"
	/>
	<AgentContactCard
		v-else-if="profile"
		:class="props.class"
		:agent-name="profile.name"
		:agent-picture-src="agentPictureSrc"
		:company-name="profile.company?.name"
		:company-logo-src="profile.company?.smallLogo"
		@submit="values => emit('submit', values)"
	/>
</template>
